package components

import androidx.compose.runtime.Composable
import frontend.lib.classList
import org.jetbrains.compose.web.dom.AttrBuilderContext
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLDivElement

@Composable
fun RoundedContainer(attrs: AttrBuilderContext<HTMLDivElement> = {},  content: @Composable () -> Unit = {}) {
    Div(attrs = {
        classList("bg-white rounded-lg shadow px-5 py-6 sm:px-6 overflow-scroll")
        attrs()
    }) {
        content()
    }
}